type Key = 'firefox' | 'chrome' | 'android' | 'ios'; // an enum might be better but its 6am i havent slept for 18hrs ill deal with this later

const main = async () => {
  try {
    const { default: UA } = await import('./vendored/ua');
    // Call it based on UA
    const ua = new UA();
    switch (true) {
      case ua.os === UA.OS.Android:
        window.location.href = 'users-android.html';
        break;
      case ua.os === UA.OS.iOS:
        window.location.href = 'users-ios.html';
        break;
      case ua.browser === UA.Browser.Firefox:
        window.location.href = 'users-firefox.html';
        break;
      case ua.browser === UA.Browser.Chromium:
        window.location.href = 'users-chrome.html';
        break;
      default:
        break;
    }
  } catch (error) {
    console.warn('Failed to load UA Detection:', error);
  }
};
main();
